<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-friends'"
            :category="$t(`sideNav.navSalonSetting`)"
            subCategory="Customize App Token"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="row">
                    <div class="col p-5">

                        <div class="custom-control custom-switch mb-3">
                            <input type="checkbox" class="custom-control-input" id="enableDisableToken" v-model="enableDisableToken" @change="onTokenStatusChange">
                            <label class="custom-control-label" for="enableDisableToken">{{enableDisableTokenLabel}}</label>
                        </div>

                        <div class="form-group" v-if="token">
                            <label class="form-label">Token</label>
                            <div class="input-group bg-white shadow-inset-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-transparent border-right-0">
                                        <i class="fas fa-key"></i>
                                    </span>
                                </div>
                                <input type="text" class="form-control bg-transparent pl-3" placeholder="Token" v-model="token" readonly @focus="$event.target.select()">
                                <div class="input-group-append" @click="onTokenRefresh">
                                    <span class="input-group-text border-right-0" style="background: #886ab5; ">
                                        <i class="fas fa-repeat" style="color: #fff"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../Bread_Crumb'
import input from '../../../assets/js/dashboard/input'
import {handleSessionExpired} from '../../../assets/js/dashboard/dashboard'

export default {
    name: 'customizeAppToken',
    components:{
        BreadCrumb
    },
    data(){
        return{
           token: '',
           enableDisableToken: 0,
           enableDisableTokenLabel: 'Enable Token',
        }
    },
    watch:{
        "$i18n.locale"(val){
        }
    },
    methods:{
        closeModal(isError){
            // if(!isError){
            //     this.getToken();
            // }
            this.$parent.isModalShow = false;
        },
        getToken(){
            let $vm = this;
            const url = 'https://devm6.tunai.io/business/app/'

            $vm.$axios({
                method: 'get', 
                url: url,
                // baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var results = response.data;
                $vm.onObtainToken(results)
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        onTokenStatusChange() {
            let $vm = this;

            const url = 'https://devm6.tunai.io/business/app/status/' + (this.enableDisableToken ? 'enable' : 'disable')
            this.$axios({
                method: 'post', 
                url: url,
                headers: {token: this.$util.getSessionToken()},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = 'Token ' + $vm.$i18n.t('message.success.success', {'action': (this.enableDisableToken ? 'enabled' : 'disabled')})
                    $vm.$parent.setModal($vm, false, true, message);

                    var results = response.data;
                    $vm.onObtainToken(results)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        onTokenRefresh(){
            let $vm = this;

            const url = 'https://devm6.tunai.io/business/app/token/refresh'
            this.$axios({
                method: 'post', 
                url: url,
                headers: {token: this.$util.getSessionToken()},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = 'Token' + $vm.$i18n.t('message.success.success', {'action': 'refreshed'})
                    $vm.$parent.setModal($vm, false, true, message);

                    var results = response.data;
                    $vm.onObtainToken(results)
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        onObtainToken(response) {
            if(!response[0] && response[0]['token']) {
                return
            }

            let $vm = this;
            $vm.token = response[0]['token']

            if($vm.token) {
                $vm.enableDisableToken = 1
                $vm.enableDisableTokenLabel = 'Disable Token'
            } else {
                $vm.enableDisableToken = 0
                $vm.enableDisableTokenLabel = 'Enable Token'
            }
        },
    },mounted(){
        let $vm = this;
        $vm.getToken()  
    }
}
</script>

<style scoped>
.img-input-group{
    padding: 0.5rem 0.65rem;
}
.img-social{
    width: 1.5em;
}
</style>